import { SignedInMethod } from '@/features/auth';

const common = [SignedInMethod.Wine, SignedInMethod.Beer, SignedInMethod.Ethanol];

export const InputToMethodMap = {
  name: common,
  fermentedAt: common,
  scaleType: [SignedInMethod.Wine],
  tank: common,
  tankVolume: common,
  yeastBrand: common,
  yeastStrain: common,
  grapeVariety: [SignedInMethod.Wine],
  vineyardSource: [SignedInMethod.Wine],
  oculyzeWineType: [SignedInMethod.Wine],
  nutrientsAtFillIn: [SignedInMethod.Wine],
  additivesAtFillIn: [SignedInMethod.Wine],
  yeastGeneration: [SignedInMethod.Beer, SignedInMethod.Ethanol],
};

/**
 * This function responsible for conditional input rendering in the create-analysis-modal
 */
export const shouldRenderInput = ({
  input,
  method,
}: {
  input: keyof typeof InputToMethodMap;
  method: SignedInMethod;
}) => {
  return InputToMethodMap[input].includes(method);
};
